import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Anchor } from '@atlaskit/primitives/anchor';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

const anchorStyles = xcss({
	display: 'inline-block',
	overflow: 'hidden',
	font: 'font.body',
	color: 'color.text.subtle',
	textDecoration: 'none',
	':hover': {
		color: 'color.text.subtle',
	},
	':visited': {
		color: 'color.text.subtle',
	},
	':focus': {
		color: 'color.text.subtle',
	},
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

const SearchMetadataLink = ({
	label,
	href,
}: {
	href: string;
	label: string;
}): React.JSX.Element => {
	return (
		<Anchor href={href} xcss={anchorStyles}>
			{label}
		</Anchor>
	);
};

export default SearchMetadataLink;
